import { getIdToken } from './getIdToken';
import { getAppCheckToken } from './getAppCheckToken';

export const getTokensInParallel = async () => {
    const [idToken, appCheckToken] = await Promise.all([getIdToken(), getAppCheckToken()]);
    return { idToken, appCheckToken };
};
